import React from 'react';
import { FaPlay, FaThumbsUp, FaStar, FaThumbtack, FaTrash } from 'react-icons/fa';
import '../styles/TrackItem.css';

const TrackItem = ({
  track,
  onPlay,
  onPin,
  onUnpin,
  isPinned,
  onDelete,
  onLike,
  onStar,
  currentUserId,
  isOwner = true,
  showPinButton = true,
  showDeleteButton = true,
  canPin = true,
}) => {
  return (
    <div className="track-item" onClick={onPlay}>
      <div className="track-item-container">
        <img src={track.coverPhoto} alt="Cover" className="cover-photo" />
        <div className="track-details">
          <p className="track-title">{track.title}</p>
          <p className="track-genre">{track.genre}</p>
          <div className="likes-plays-container">
            <div className="play-container">
              <FaPlay size={16} color="#fff" />
              <span className="play-count">{track.plays || 0}</span>
            </div>
            <button
              onClick={(e) => {
                e.stopPropagation();
                onLike();
              }}
              className="like-container"
            >
              <FaThumbsUp
                size={16}
                color={
                  track.likedBy && track.likedBy.includes(currentUserId)
                    ? '#ff5349'
                    : '#fff'
                }
              />
              <span className="like-count">{track.likes || 0}</span>
            </button>
            {onStar && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onStar();
                }}
                className="star-container"
              >
                <FaStar
                  size={16}
                  color={
                    track.starredBy && track.starredBy.includes(currentUserId)
                      ? '#ff5349'
                      : '#fff'
                  }
                />
                <span className="star-count">{track.stars || 0}</span>
              </button>
            )}
          </div>
        </div>
        {showPinButton && isOwner && canPin && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              isPinned ? onUnpin() : onPin();
            }}
            className="pin-button"
          >
            <FaThumbtack
              size={16}
              color={isPinned ? '#ff5349' : '#fff'}
            />
          </button>
        )}
        {showDeleteButton && isOwner && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              if (window.confirm('Are you sure you want to delete this track?')) {
                onDelete();
              }
            }}
            className="delete-button"
          >
            <FaTrash size={16} color="#fff" />
          </button>
        )}
      </div>
    </div>
  );
};

export default TrackItem;